class AdpMonthIndicatorController {
  constructor() {
    this.name = 'adpMonthIndicator';
  }

  $onChanges (changes) {
    if (changes.items) {
      this.startIndex = changes.items.currentValue.indexOf(changes.items.currentValue.find(i => i.start));
      this.endIndex = changes.items.currentValue.indexOf(changes.items.currentValue.find(i => i.end));

      this.selectedStartIndex = changes.items.currentValue.indexOf(changes.items.currentValue.find(i => i.cycleStart));
      this.selectedEndIndex = changes.items.currentValue.indexOf(changes.items.currentValue.find(i => i.cycleEnd));
    }
  };
  
}

export default AdpMonthIndicatorController;



// WEBPACK FOOTER //
// ./src/app/components/adpPeriodIndicator/adpPeriodIndicator.controller.js